import {useDispatch} from "react-redux";
import {toast} from "react-toastify";
import {useEffect, useState} from "react";
import {useTranslation} from "react-i18next";
import {errorMsg, userListToLabelEmailPhoneValue} from "../../../../Apis/functions";
import {
    CreateUserZoneList,
    DeleteZoneUser,
    ZoneDetailAuthorizedEmployeeNoPagination
} from "../../../../reduxToolkit/EmployeeZones/EmployeeZonesApi";
import {PersonChipBlack} from "../../../../components/buttons/IconButtons";

/**
 * @Email : kpozos@ibl.mx
 * @Author: Karen Yunuen Pozos Arias
 * @jobTittle: Full Stack Developer
 *
 */

export const ManageAuthorizedEmployeeApp = ({ onHide, selectedId, setModified }) => {
    const dispatch = useDispatch();
    const {t} = useTranslation(); // Initialize the translation function
    const [results, setResults] = useState([]);

    useEffect(() => {
        if(selectedId) getData();
    }, [selectedId])

    const getData = () => {
        dispatch(ZoneDetailAuthorizedEmployeeNoPagination(selectedId)).then(
            ({payload: {data: {success, data },},}) =>
            {
                if (success === true) {
                    setResults(userListToLabelEmailPhoneValue(data || [], "userId", false, PersonChipBlack))
                }
            },
        );
    }

    const handleDelete = (dId) => {
        const data = {
            userIds: [dId],
            zoneId: selectedId,
        };
        dispatch(DeleteZoneUser(data)).then(
            ({payload: {data: { success, code },},}) =>
            {
                if (success === true) {
                    toast.success(t('has_been_deleted_successfully'));
                    setModified(true);
                    getData();
                } else errorMsg(code);
            },
        );
    };

    /**
     * Handles the addition of selected users to the department.
     * Dispatches an action to update the department with new user IDs.
     */
    const handleAdd = (items) => {
        const ids = items.map((item) => item.id);

        const data = {
            list: ids,
            zoneId: selectedId,
        };

        dispatch(CreateUserZoneList(data)).then(({payload: {data: {success},},}) => {
                if (success === true) {
                    toast.success(t('has_been_added_successfully')); // Show success message
                    setModified(true);
                    onHide();
                }
            },
        );
    };

    return {
        t, // Translation
        handleDelete,
        handleAdd,
        selectedEmployee: results,
    };
};
